import React from 'react';
import logo from '../assets/logo.png';

const Header = () => {
  return (
    <header className="header">
      <div className="logo-box">
        <img src={logo} alt="Fabria" />
      </div>
      <div style={{letterSpacing: '2px', fontSize: '0.7rem', fontWeight: '600'}}>
        Créations artisanales
      </div>
    </header>
  );
};

export default Header;
